import { formatDistanceToNow, parseISO } from 'date-fns';
import dayjs from 'dayjs';

/**
 * Converts a modified filter preset value to an ISO date string for modified_from
 * @param {string} preset - The preset value ('last_7_days', 'last_30_days', 'this_year')
 * @returns {string|null} - ISO date string or null if preset is invalid
 */
export const getModifiedFromDate = (preset) => {
  if (!preset) return null;
  
  const now = dayjs();
  
  switch (preset) {
    case "last_7_days":
      return now.subtract(7, 'day').startOf('day').toISOString();
    case "last_30_days":
      return now.subtract(30, 'day').startOf('day').toISOString();
    case "this_year":
      return now.startOf('year').toISOString();
    default:
      return null;
  }
};

export const formatLastUpdated = (dateString) => {
  try {
    const date = parseISO(dateString);
    const distance = formatDistanceToNow(date, { addSuffix: false });

    // Customize the output based on the distance
    if (distance.includes('less than a minute') || distance.includes('minute')) {
      return {
        label: 'Today',
        tooltip: 'Just now'
      };
    }

    if (distance.includes('hour')) {
      return {
        label: 'Today',
        tooltip: `${distance} ago`
      };
    }

    if (distance === '1 day') {
      return {
        label: 'Yesterday',
        tooltip: '24 hours ago'
      };
    }

    if (distance.includes('days') && parseInt(distance) <= 7) {
      return {
        label: 'Last week',
        tooltip: `${distance} ago`
      };
    }

    if (distance.includes('days') && parseInt(distance) <= 14) {
      return {
        label: '2 weeks ago',
        tooltip: `${distance} ago`
      };
    }

    // For anything older than 2 weeks
    return {
      label: distance,
      tooltip: dateString
    };
  } catch (error) {
    console.error('Error formatting date:', error);
    return {
      label: 'Unknown',
      tooltip: dateString
    };
  }
};
